import { Calculator } from "lucide-react";
import { computeMargin } from "@/data/events";

const eur = (v) => v.toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
const inp = "w-full min-h-[48px] rounded-xl border border-[#E3D5C3] bg-white px-3 py-2 text-base text-[#2C221E] outline-none focus:border-[#C85A32] print:border-0 print:px-0 print:min-h-0";

const FIELDS = [
  ["pricePerCover", "Prezzo a coperto (€)"],
  ["foodPerCover", "Costo cibo a coperto (€)"],
  ["staff", "Personale del giorno (€ totale)"],
  ["extras", "Allestimenti, fiori, musica (€)"],
  ["other", "Altri costi: lavanderia, energia, extra (€)"],
];

export const EventCosts = ({ ev, onChange }) => {
  const costs = ev.costs || {};
  const m = computeMargin(ev);
  const tone = m.revenue === 0 ? "#8A7970" : m.pct >= 35 ? "#2E6B40" : m.pct >= 20 ? "#C27D00" : "#A83232";
  const verdict = m.revenue === 0 ? "Inserisci prezzo e coperti" : m.pct >= 35 ? "Margine sano: si può dire sì" : m.pct >= 20 ? "Margine stretto: rivedere costi o prezzo" : "Margine insufficiente: non conviene così";
  return (
    <section data-testid="event-costs">
      <div className="flex items-center gap-2 mb-3">
        <Calculator className="text-[#2D4030]" size={20} />
        <h2 className="font-serif text-2xl font-semibold text-[#2D4030]">Scheda costi e margine</h2>
      </div>
      <div className="grid md:grid-cols-[1fr_280px] gap-6">
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block">
              <span className="eyebrow">{label}</span>
              <input type="number" inputMode="decimal" min="0" className={`${inp} mt-1.5`} value={costs[k] ?? ""} onChange={(e) => onChange({ ...costs, [k]: e.target.value })} data-testid={`cost-${k}`} />
            </label>
          ))}
        </div>
        <div className="rounded-2xl p-5 border" style={{ background: `${tone}10`, borderColor: `${tone}55` }} data-testid="margin-box">
          <p className="eyebrow">Risultato</p>
          <p className="font-serif text-4xl font-bold mt-1" style={{ color: tone }} data-testid="margin-value">{eur(m.margin)}</p>
          <p className="text-sm font-semibold mt-1" style={{ color: tone }} data-testid="margin-pct">{m.pct}% del ricavo · {eur(m.perCover)} a coperto</p>
          <dl className="text-sm text-[#5C4D46] mt-4 grid gap-1">
            <div className="flex justify-between"><dt>Ricavo ({ev.guests || 0} coperti)</dt><dd>{eur(m.revenue)}</dd></div>
            <div className="flex justify-between"><dt>Cibo</dt><dd>− {eur(m.food)}</dd></div>
            <div className="flex justify-between"><dt>Personale</dt><dd>− {eur(Number(costs.staff) || 0)}</dd></div>
            <div className="flex justify-between"><dt>Allestimenti e altro</dt><dd>− {eur((Number(costs.extras) || 0) + (Number(costs.other) || 0))}</dd></div>
          </dl>
          <p className="text-sm mt-4 font-semibold" style={{ color: tone }} data-testid="margin-verdict">{verdict}</p>
        </div>
      </div>
    </section>
  );
};
